import * as React from 'react';
import { connect } from 'react-redux';

import ResponsesManager from './responsesManager';

import { ResponseRouteWrapper } from '../../../Shared/index';
import FillInBlankResponsesManagerWrapper from '../fillInBlankActivities/fillInBlankResponsesManagerWrapper';

const GrammarResponseRouteWrapper: React.FC<any> = (props) => {
  const { match, questions, fillInBlank, } = props
  const questionID = match.params.questionID;

  const questionFromQuestions = questions && questions[questionID];
  const questionFromFillInBlank = fillInBlank?.data?.[questionID];
  const question = questionFromFillInBlank || questionFromQuestions;

  const isFillInBlank = question && question.prompt && question.prompt.includes('___');

  const ManagerComponent = isFillInBlank
    ? FillInBlankResponsesManagerWrapper
    : ResponsesManager;

  return (
    <ResponseRouteWrapper
      {...props}
      additionalDatasets={['fillInBlank']}
      ResponsesManager={ManagerComponent}
    />
  );
};

function select(state) {
  return {
    questions: state.questions,
    fillInBlank: state.fillInBlank,
  };
}

export default connect(select)(GrammarResponseRouteWrapper);
